import { render, staticRenderFns } from "./DivideItRight.vue?vue&type=template&id=df9630fa&lang=pug&"
import script from "./DivideItRight.vue?vue&type=script&lang=js&"
export * from "./DivideItRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports